<template>
    <el-input  @keyup.native.enter="$emit('search')" placeholder="Buscar" v-model="value"  :class="`${getPrimaryColor} filter search`" @clear="$emit('change', value)" clearable @keyup.native="$emit('change', value)">
        <button class="btn" slot="append" @click="$emit('search')">
            <SearchIcon class="mx-0" size="16" />
        </button>
    </el-input>
</template>

<script>
export default {
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            default: ''
        },
    },
    data() {
        return {
            value: this.model
        }
    },
}
</script>